import React, { useContext, useState, useEffect } from "react";
import "../../../index.css";
import { TeamsFxContext } from "../../Context";
import * as microsoftTeams from "@microsoft/teams-js";

export const Assets = () =>{
    const [system, setSystem] = useState(null);
    const [selectedModelCategoryTab, setSelectedModelCategoryTab] = useState('');
    const [selectMainTab, setSelectedMainTab]= useState('Asset');
    const n=15;
    const [formattedResponseData, setformattedResponseData]= useState(null);
    const reactFunctionEndpoint= process.env.REACT_APP_FUNCTION_ENDPOINT;        
    const {userPrincipalName, accessToken} = useContext(TeamsFxContext);
    const [accesstoken, setToken]= useState(null);

     useEffect(()=> {
            const fetchToken = async() =>{
            try{
                await microsoftTeams.app.initialize();
                const ssoToken =await microsoftTeams.authentication.getAuthToken();
                setToken(ssoToken);
            } catch (err){
                console.err("Token check error: ", err);
            }
            };
            fetchToken();
        },[]);


    useEffect(() => {
        console.log("userPrincipalName : ",userPrincipalName);
        
        if (userPrincipalName && accesstoken ) {
            const fetchSystemData = async () => {
                try {

                    const response = await fetch(`${reactFunctionEndpoint}/api/getServiceNowAPIData?type=asseturl&inputvalue=${userPrincipalName}`,
                        {
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${accesstoken}`,
                            },
                        }
                    );

                    const result = await response.json();
                    setSystem(result);
                } catch (err) {
                } finally { }
            };
            fetchSystemData();
        }
    }, [userPrincipalName,accesstoken]);

    useEffect(() => {
        if (userPrincipalName && accesstoken) {
            const fetchlicenseData = async () => {
                try {
                    const response = await fetch(`${reactFunctionEndpoint}/api/getServiceNowAPIData?type=license&inputvalue=${userPrincipalName}`,
                        {
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${accesstoken}`,
                            },
                        }
                    );

                    const responseData = await response.json();
                    const delimiter = ' | ';
                    const dynamicKey = 'applicationLicenses';
                    
                    if(responseData.length>0){
                        const item=responseData[0];
                        const formattedStrings=[];

                        if(Array.isArray(item[dynamicKey])){
                            const formattedValue= item[dynamicKey].join(delimiter);
                            formattedStrings.push(`${dynamicKey}: ${formattedValue}`);
                            //setformattedResponseData(formattedValue);
                        }
                        Object.keys(item).forEach((key)=>{
                            if(key!==dynamicKey){
                                formattedStrings.push(`${key}: ${item[key]}`);
                            }
                        });
                        const combinedString = formattedStrings.join(', ');
                        const split_combinedString = (combinedString.split(', '));
                        setformattedResponseData(split_combinedString);
                    }
                } catch (err) {} finally { }
            };
            fetchlicenseData();
        }
    }, [userPrincipalName,accesstoken]);

    const formatKeyValue = (item) => {
        const [key, value] = item.split(':');
            return{
                key: key.trim(),
                value:value.trim()
            }
    }

    const capitalizeFirstLetter = (str) => {
        if(!str) return'';
        return str.charAt(0).toUpperCase() + str.slice(1);
    };

    const columnsToRemove = ['cpu', 'memory','hardDrive','ipAddress','userName'];
    const groupByModelCategory = (system, columnsToRemove) => {
        if (!Array.isArray(system)) { return{};}

        return system.reduce((acc, item) => {
          const { modelCategory } = item;   

          if (!acc[modelCategory]) {
            acc[modelCategory] = [];
          }

          const filteredItem = {...item};
        
        if(Array.isArray(columnsToRemove)){
          if(modelCategory!=='Computer' && modelCategory !=='Virtual Desktop'){
            columnsToRemove.forEach(column=>{
                delete filteredItem[column];
              });
          }
          delete filteredItem['retiredDate'];
          delete filteredItem['state'];
        }
          acc[modelCategory].push(filteredItem);
          return acc;         
        }, {});
    };
    
    const priorityOrder = {'Computer':1, 'Virtual Desktop':2,};
    const groupedSystem = groupByModelCategory(system, columnsToRemove);

    const modelCategories = Object.keys(groupedSystem);
    //console.log('Initial Model Categories: ', modelCategories);

    const sortedCategories = modelCategories.sort((a,b)=>{

        const aPriority = priorityOrder[a] || 3;
        const bPriority = priorityOrder[b] || 3;

        //console.log(`Comparing ' ${a}' with ' ${b}`);

        return aPriority - bPriority;
    });

    useEffect(() => {
        if (Object.keys(groupedSystem).length>0 && !selectedModelCategoryTab) {
            setSelectedModelCategoryTab(Object.keys(groupedSystem)[0]);
        }
    },[groupedSystem, selectedModelCategoryTab]);

    const handleMainTabClick = (tabName) => {
        setSelectedMainTab(tabName);
        setSelectedModelCategoryTab(null);
    };

    const handleModelCategoryClick = (modelCategory) => {
        setSelectedModelCategoryTab(modelCategory);
    };

    /* useEffect(()=> {
        if (modelCategories. includes('Computer')){
            setSelectedModelCategoryTab('Computer');
         } else if (modelCategories.includes('Virtual Desktop')){
            setSelectedModelCategoryTab('Virtual Desktop');
          } else {
            setSelectedModelCategoryTab(modelCategories[0]);
          } 
        }, [modelCategories]); */

    const getRetirementDateColor=(scheduledRetirement) => {
        if (scheduledRetirement){
        let currentDate = new Date()
        let retirement = new Date(scheduledRetirement);
        let diffTime = retirement - currentDate;
        let diffDays = Math.ceil(diffTime / (1000*60*60*24));

        if(diffDays < 0) { 
            return 'red';
        } else if (diffDays <= 14) {
            return 'orange';
        } else {
            return 'white';
        }
    }
    };

    const includeSpaceBetweenWords= (str) =>{
        if(str == 'computerName'){
            return (str.replace('computerName', 'Computer name'));
        } else if (str=='hardDrive'){
            return (str.replace('hardDrive', 'Hard drive'));
        } else if (str=='serialNumber'){
            return (str.replace('serialNumber', 'Serial number'));
        } else if (str=='retiredDate'){
            return (str.replace('retiredDate', 'Retired date'));
        } else if (str=='ipAddress'){
            return (str.replace('ipAddress', 'IP address'));
        } else if (str=='userName'){
            return (str.replace('userName', 'User name'));
        } else if (str=='warrantyStartDate'){
            return (str.replace('warrantyStartDate', 'Warranty start date'));
        } else if (str=='scheduledRetirement'){
            return (str.replace('scheduledRetirement', 'scheduled retirement'));
        } else if (str=='assetName'){
            return (str.replace('assetName', 'Asset name'));
        } else if (str=='modelCategory'){
            return (str.replace('modelCategory', 'Model category'));
        } else {
            return capitalizeFirstLetter(str);
        }
    };

    return( <div className="main-container">
        <p className="tabHeader">Asset / License</p>
        {/*Main tabs: Assets and Licenses */}
        <div className="main-tabs-container">
            <div onClick={()=> handleMainTabClick('Asset')}
                className = {`main-tab ${selectMainTab === 'Asset' ? 'main-tab-active':''}`}
                >Assets 
            </div>
            <div onClick={()=> handleMainTabClick('License')}
            className = {`main-tab ${selectMainTab === 'License'? 'main-tab-active' : ''}`
            }
            >
                License
            </div>
        </div>         
        
        {/* Content of tabs */}
        {selectMainTab === 'Asset'&&(
            <div className="sub-container">
                {/* Sub-tabs for Assets */}
                <div className="sub-tabs-container">
                    {sortedCategories.map((modelCategory) => (
                        <div key={modelCategory}
                        onClick={()=> handleModelCategoryClick(modelCategory)}
                        className = {`sub-tab ${selectedModelCategoryTab === modelCategory ? 'sub-tab-active':''}`}
                    >
                        {modelCategory}
                        </div>
                    ))}
                </div>

                {/* Data display section */}

                <div className="data-content"> 
                {selectedModelCategoryTab  && groupedSystem[selectedModelCategoryTab]? (
                    <table style={{borderCollapse: 'separate', borderSpacing: '5px 5px'}}>
                        <tbody>
                            {groupedSystem[selectedModelCategoryTab].map((item)=>(
                                <React.Fragment key={item.serialNumber}>
                                <tr>
                                    <td style={{fontFamily:'Segoe UI' ,fontSize:'13px'}}>Asset Name: </td>
                                    <td style={{fontFamily:'Segoe UI' ,fontSize:'13px',color:'#1e90ff'}}><a href={item.assetURL} color="inherit" target="blank" rel="noopener noreferrer">
                                        <strong> {item.assetName}</strong>
                                    </a> </td>
                                </tr>

                                {Object.keys(item).map((key)=> 
                                                key !== 'assetName' && key !== 'scheduledRetirement' && key!=='assetURL' ? (
                                                    <tr key={key}>
                                                        <td style={{fontFamily:'Segoe UI' ,fontSize:'13px'}}> {`${includeSpaceBetweenWords(key)}:`} </td>
                                                        <td style={{fontFamily:'Segoe UI' ,fontSize:'13px'}}>{item[key]} </td>
                                                    </tr>
                                                ) : null
                                            )}
                                {item.scheduledRetirement && (
                                    <tr>
                                        <td style={{fontFamily:'Segoe UI' ,fontSize:'13px'}}> Scheduled retirement: </td>
                                        <td style={{fontFamily:'Segoe UI' ,fontSize:'13px',color:getRetirementDateColor(item.scheduledRetirement)}}>
                                            {item.scheduledRetirement}
                                        </td>
                                    </tr>
                                )} 

                                <tr>
                                    <td colSpan='2' style={{borderBottom: '1px solid #808080', padding: '7px'}}> </td>
                                </tr>
                                </React.Fragment>
                                        ))}
                        </tbody>
                    </table>
                ):(<p> No asset details available. </p>
                )} </div> 
                </div>
        )}
        {selectMainTab === 'License' && (
            <div className="data-content">
                <table className="table license-table" style={{ width:'50%'}}>
                    <thead> 
                        <tr> 
                        <th> License type </th>
                        <th> License value </th>
                        </tr>
                    </thead>
                    <tbody> {formattedResponseData.map((item, index)=>{
                        const formattedItem = formatKeyValue(item);
                        return(
                        <tr key={index}>
                            <td style={{padding: '4px'}}>{capitalizeFirstLetter(formattedItem.key) +" :"}</td>
                            <td style={{padding:'4px'}}>{formattedItem.value}</td>
                        </tr>);})}
                    </tbody>
                    </table>
                </div>
        )}
        </div>

)};
